import moment from "@/utils/moment";

const christmasEve = {
  name: "Véspera de Natal",
  day: "12-24",
  activePurchase: true,
  max_starts_at: 15
};

const christmasEve23 = {
  name: "Véspera de Natal",
  day: "12-23",
  activePurchase: true
};

const christmas = {
  name: "Natal",
  day: "12-25",
  activePurchase: false
};

const newYearEve = {
  name: "Véspera de Ano Novo",
  day: "12-31",
  activePurchase: true
};

const newYear = {
  name: "Ano Novo",
  day: "01-01",
  activePurchase: false
};

const holidays = [christmasEve, christmas, newYearEve, newYear, christmasEve23];

const dayFormat = "MM-DD";

const formatDay = day => moment(day).format(dayFormat);
const findHoliday = day => {
  day = formatDay(day);
  return holidays.find(el => el.day === day);
};
const daysWithDisabledPurchase = () =>
  holidays.filter(el => !el.activePurchase).map(el => el.day);

export default {
  daysWithDisabledPurchase,
  findHoliday,
  holidays,
  dayFormat
};



// WEBPACK FOOTER //
// ./src/utils/helpers/holiday.js